import React, { FC } from 'react';
import AgileLayout from '@components/agile/layout/AgileLayout';
import '@components/shared/Agile/AgileBase.css';
import { Outlet } from 'react-router-dom';

const AgileHome: FC = () => {
  return (
    <AgileLayout>
      <Outlet />
    </AgileLayout>
  );
};
export default AgileHome;
